import Styles from './CampaignDetails.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { ChevronRightSmall } from 'blaze-ui/icons'
import { useState } from 'react'
import cx from 'classnames'
import { ContentModificationItem, ContentModificationVariant } from './ContentModificationItem'

interface Props {
  contentModificationVariant: ContentModificationVariant
  onContentModificationVariantChange: (variant: ContentModificationVariant) => void
  alwaysExpanded?: boolean
}

export const VisualContentSettings = ({
  contentModificationVariant,
  onContentModificationVariantChange,
  alwaysExpanded = false,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggle = () => {
    if (alwaysExpanded) return
    setIsExpanded((prev) => !prev)
  }

  const expanded = alwaysExpanded || isExpanded

  return (
    <div className={cx(Styles.expandableSection, { [Styles.alwaysExpanded]: alwaysExpanded })}>
      <div className={Styles.expandableSectionTrigger} onClick={handleToggle}>
        <div className={Styles.section}>
          <div>
            <Heading level={4}>Visual content settings</Heading>
            <Text variant="secondary" color="var(--dark-40)">
              Change workspace defaults only for this campaign
            </Text>
          </div>
        </div>
        {!alwaysExpanded && (
          <div className={cx(Styles.chevron, { [Styles.expanded]: expanded })}>
            <ChevronRightSmall size={15} />
          </div>
        )}
      </div>
      <div className={cx(Styles.expandableSectionContent, { [Styles.expanded]: alwaysExpanded || isExpanded })}>
        <div className={Styles.separator} />
        <div className={Styles.sectionSetting}>
          <div className={Styles.section}>
            <div className={Styles.sectionTitle}>
              <Text>Visual Content Modification</Text>
              <Text variant="secondary" color="var(--dark-40)">
                Blaze uses AI to generate asset variants from your Brand Kit, tailored to your goals, strategies, and
                topics. Choose how to balance asset fidelity with goal optimization.
              </Text>
            </div>
            <div className={Styles.contentModificationGrid}>
              <ContentModificationItem
                selected={contentModificationVariant === 'high'}
                variant="high"
                onSelect={onContentModificationVariantChange}
              />
              <ContentModificationItem
                selected={contentModificationVariant === 'medium'}
                variant="medium"
                onSelect={onContentModificationVariantChange}
              />
              <ContentModificationItem
                selected={contentModificationVariant === 'low'}
                variant="low"
                onSelect={onContentModificationVariantChange}
              />
              <ContentModificationItem
                selected={contentModificationVariant === 'none'}
                variant="none"
                onSelect={onContentModificationVariantChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
